<div class="wrapper">
    <div class="divwrapper">
      <div  class="divwrapper"   >
        <span *ngIf="valveStatus.val > 0 ; else valveoff" class="divwrapper k-icon k-i-play k-icon-24"></span>
      </div>
      <ng-template #valveoff>
        <span  class="divwrapper k-icon k-i-stop-sm k-icon-24"></span>
      </ng-template>
        Valve <b>  {{ branchMathValve ? branchMathValve.fullnumber.constvalue.value : "" }} </b>
    </div>
    <div id="today"  >
       {{ GetValue(volumeToDay) }}
    </div>
    <div id="yesterday" >
       {{ GetValue(volumeYesterDay) }}
    </div>
    <app-unit id="unit" *ngIf="branchMathValve" [unit]="branchMathValve.volumetoday.variable.unit"></app-unit>
</div>
